angular.module('tgaAdmin').directive('minutesToSeconds', () => ({
  restrict: 'A',
  require: 'ngModel',
  link(scope, element, attrs, ngModel) {
    if (ngModel) {
      ngModel.$parsers.push((value) => value * 60);

      ngModel.$formatters.push((value) => {
        if (value === null) {
          return;
        }
        // eslint-disable-next-line consistent-return
        return value / 60;
      });
    }
  },
}));
